<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ messageStatus.message }}
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-12">
            <div class="card-body">
              <form>
                <div class="row g-2">
                  <div class="col-12 input-trend-search">
                    <input
                      type="search"
                      #searchBox
                      class="form-control"
                      [placeholder]="'shared.reportAttendance.searchPlaceholder' | translate"
                      (input)="onSearch(searchBox.value)"
                      (keyup)="onSearch(searchBox.value)"
                    />
                    <span class="mdi mdi-magnify search-icon ml-2"></span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        @if (loadingContent) {
        <content-loading-list />
        } @if (!loadingContent && pager.total > 0) {
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnCreatedAt' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnChannel' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnDepartment' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnUser' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnPhone' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'shared.reportAttendance.columnAgent' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
              <tr>
                <td>
                  <span>
                    {{
                      $safeNavigationMigration(item?.createdAt)
                        | timezoneDate
                          : "DD/MM/YYYY HH:mm:ss"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </span>
                </td>
                <td>
                  <span>{{ item?.channel }}</span>
                </td>
                <td>
                  <span>{{ item?.department }}</span>
                </td>
                <td>
                  <span>{{ item?.contact }}</span>
                </td>
                <td>
                  <span>{{ formatPhone($safeNavigationMigration(item?.phone)) }}</span>
                </td>
                <td>
                  <span>{{ item?.user }}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
          @if (pager.total > pager.perPage) {
          <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
          }
        </div>
        } @else {
        <empty-records-component
          [message]="'shared.reportAttendance.emptyMessage' | translate"
          [subMessage]="'shared.reportAttendance.emptySubMessage' | translate"
          [icon]="'mdi mdi-alert-circle-outline'"
        />
        }
      </div>
    </div>
  </div>
</div>
